import FetchClient, { type ApiResponse } from "./FetchClient";

export interface DGPennyListItem {
  name: string;
  image?: string;
  /** Full UPC, or "••••1234" when the server masked it. */
  upc: string;
  upcMasked?: boolean;
  regularPrice?: number;
  confirmedAt: string;
}

export interface DGPennyList {
  generatedAt: string;
  weekStart: string;
  newThisWeek: number;
  activeTotal: number;
  unmaskedLimit: number;
  items: DGPennyListItem[];
}

export interface HDPennyCheck {
  query: string;
  found: boolean;
  item?: {
    /** Only the identifier the caller searched by is echoed back. */
    sku?: string;
    itemId?: string;
    name?: string;
    brand?: string;
    image?: string;
    regularPrice?: number;
  };
  community?: { reported: boolean; states?: string[]; lastReportedAt?: string; receipt?: boolean };
  dealhawk: { flagged: boolean; storeBand?: "one" | "few" | "many" | "chainwide" };
  generatedAt?: string;
}

/** This week's store-confirmed Dollar General penny items. Signed-in requests get every UPC. */
export async function getDGPennyList(): Promise<DGPennyList> {
  const response = await FetchClient.get<ApiResponse<DGPennyList>>("/public/tools/dg-penny-list", {}, "optional");
  return response.data;
}

/** One Home Depot SKU or Internet # against DealHawk's penny signals. Rate-limited; may trigger Turnstile. */
export async function checkHDPenny(query: string): Promise<HDPennyCheck> {
  const response = await FetchClient.get<ApiResponse<HDPennyCheck>>(
    `/public/tools/hd-penny-check?q=${encodeURIComponent(query)}`,
    {},
    true,
  );
  return response.data;
}
